// 学习力测评只采集本次报告资料，手机号不属于报告身份。
export function learningProfileFields(fields) {
  return Object.keys(fields || {}).reduce((result, key) => {
    if (key !== 'phone' && key !== 'code') result[key] = fields[key];
    return result;
  }, {});
}

export function copyLearningProfile(fields, profile) {
  return Object.keys(learningProfileFields(fields)).reduce((result, key) => {
    const value = (profile || {})[key];
    result[key] = typeof value === 'string' ? value.trim() : '';
    return result;
  }, {});
}

export function hasLearningProfile(fields, profile) {
  const keys = Object.keys(learningProfileFields(fields));
  if (!keys.length || keys.some(key => !profile[key] || profile[key] === '-请选择-')) return false;
  const grades = {
    '小学生': ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级'],
    '初中生': ['初一', '初二', '初三'],
    '高中生': ['高一', '高二', '高三'],
    '大学生': ['大一', '大二', '大三', '大四', '大五'],
    '研究生': ['研一', '研二', '研三'],
    '职场人': ['0-3年', '4-5年', '6-10年', '10年以上']
  };
  if (keys.includes('_identity2') && !(grades[profile._identity2] || []).includes(profile._identity3)) return false;
  if (keys.includes('_gender') && !['男', '女'].includes(profile._gender)) return false;
  return true;
}
